window.__resources = {};

/* ---- Split from original inline <script> ---- */

// Nav scroll state
const nav = document.getElementById('nav');

if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  });
}

// Fade-up on scroll — exclude hero elements so they're visible immediately on load
const faders = document.querySelectorAll('.sec-head, .tier, .how-step, .coll-card, .test-card, .about-img, .about-text, .sourcing-list li');

faders.forEach(el => el.classList.add('fade-up'));

const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('in');
      io.unobserve(e.target);
    }
  });
}, { threshold: 0.12 });

faders.forEach(el => io.observe(el));

// Tier selected state (visual)
document.querySelectorAll('.tier').forEach(t => {
  t.addEventListener('click', (e) => {
    if (e.target.closest('a')) return;

    document.querySelectorAll('.tier').forEach(x => x.classList.remove('featured'));
    t.classList.add('featured');
  });
});

// Remove Shopify contact form success state after submission
if (window.location.search.includes('contact_posted=true')) {
  const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
  window.history.replaceState({}, document.title, cleanUrl);
}